import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
	data: {
		id: 0,
		statement: null,
		answers: [],
		correctAnswer: null,
		motivation: null,
		subject: null,
		difficulty: null,
		chapter: null,
		source: null
	},
	sources: [],
	error: null,
	loading: false,
	historyInteractive: []
};

const setHistoryInteractive = (state, action) => {
	let newHistory = [...state.historyInteractive, action.answer];
	if (newHistory.length > 5) {
		newHistory = newHistory.slice(newHistory.length - 5);
	}
	return updateObject(state, { historyInteractive: newHistory });
};

const resetHistoryInteractive = (state) => updateObject(state, { historyInteractive: [] });

const fetchInteractiveQuestionStart = (state) =>
	updateObject(state, { loading: true, error: null });

const fetchInteractiveQuestionSuccess = (state, action) =>
	updateObject(state, {
		loading: false,
		data: {
			id: action.data.ID,
			statement: action.data.Statement,
			answers: action.data.Answers,
			correctAnswer: action.data.CorrectAnswerId,
			motivation: action.data.Motivation,
			difficulty: action.data.Difficulty,
			subject: action.data.Subject,
			chapter: action.data.Chapter,
			type: action.data.Type,
			source: action.data.Source
		}
	});

const fetchInteractiveQuestionFail = (state, action) =>
	updateObject(state, { error: action.error, loading: false });

const fetchQuestionsSuccess = (state, action) =>
	updateObject(state, {
		data: action.data,
		loading: false,
		sources: action.sources
	});

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case actionTypes.FETCH_INTERACTIVE_QUESTION_START:
			return fetchInteractiveQuestionStart(state, action);
		case actionTypes.FETCH_INTERACTIVE_QUESTION_SUCCESS:
			return fetchInteractiveQuestionSuccess(state, action);
		case actionTypes.FETCH_INTERACTIVE_QUESTION_FAIL:
			return fetchInteractiveQuestionFail(state, action);
		case actionTypes.SET_HISTORY_INTERACTIVE:
			return setHistoryInteractive(state, action);
		case actionTypes.RESET_HISTORY_INTERACTIVE:
			return resetHistoryInteractive(state);
		case actionTypes.FETCH_QUESTION_SUCCESS:
			return fetchQuestionsSuccess(state, action);
		default:
			return state;
	}
};

export default reducer;
